import React from 'react';

function Home() {
  return <div className="App">Dashboards</div>;
}

export default Home;
